import { Fragment } from 'react';
import { Link } from '../lib/router';

const TOKEN = /([#@][\p{L}\p{N}_.]+)/gu;

/** Renders text with #hashtags and @mentions as links. */
export function RichText({ text, className }: { text: string; className?: string }) {
  const parts = text.split(TOKEN);
  return (
    <span className={className}>
      {parts.map((p, i) => {
        if (p.startsWith('#') && p.length > 1) {
          return (
            <Link key={i} to={`/tag/${encodeURIComponent(p.slice(1).toLowerCase())}`} style={{ fontWeight: 700 }} onClick={(e) => e.stopPropagation()}>
              {p}
            </Link>
          );
        }
        if (p.startsWith('@') && p.length > 2) {
          const name = p.slice(1).replace(/\.$/, '');
          return (
            <Link key={i} to={`/u/${encodeURIComponent(name.toLowerCase())}`} style={{ fontWeight: 700 }} onClick={(e) => e.stopPropagation()}>
              @{name}
            </Link>
          );
        }
        return <Fragment key={i}>{p}</Fragment>;
      })}
    </span>
  );
}
